<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card v-if="course">
            <v-toolbar flat color="#008dd4" dark>
                <v-btn icon @click="$parent.students_dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Alumnos por curso : {{ course.name }}</v-toolbar-title>
            </v-toolbar>
            <v-container class="py-0" fluid>
                <v-row>
                    <v-col cols="12" class="pa-0">
                        <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
                    </v-col>
                    <v-col lg="3" md="12" sm="12" xs="12" style="position:relative; top: -60px">
                        <v-card>
                            <v-list two-line subheader>
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-icon color="#008dd4" x-large>mdi-account-box</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title><strong>Total de Alumnos válidados</strong></v-list-item-title>
                                        <v-list-item-subtitle class="text-h4">{{ total_students_verified }}</v-list-item-subtitle>
                                    </v-list-item-content>

                                </v-list-item>
                            </v-list>
                        </v-card>

                        <v-card class="mt-3">
                            <v-list two-line subheader>
                                <v-list-item>
                                    <v-list-item-avatar>
                                        <v-icon color="#008dd4" x-large>mdi-account-box</v-icon>
                                    </v-list-item-avatar>

                                    <v-list-item-content>
                                        <v-list-item-title><strong>Total de Alumnos registrados</strong></v-list-item-title>
                                        <v-list-item-subtitle class="text-h4" v-if="course.students">{{ course.students.length }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-col>
                    <v-col lg="9" md="12" sm="12" xs="12" style="position:relative; top: -60px">
                        <v-card v-if="course.students && course.students.length > 0">
                            <v-card-text>
                                <v-data-table
                                    :headers="sbc_headers"
                                    :items="course.students"
                                    :loading="sbc_loading"
                                    :footer-props="footer_props"
                                    :loading-text="loading_text"
                                    :no-data-text="no_data_text"
                                    :no-results-text="no_result_text"
                                    :search="sbc_search"
                                    :items-per-page="sbc_itemsPerPage"
                                >
                                    <template v-slot:top>
                                        <v-container class="py-0">
                                            <v-row justify="end" align="center">
                                                <v-col cols="12" >
                                                    <v-textarea
                                                        rows="3" v-model="whatsapp_message" outlined name="input-7-4" label="Mensaje de inicio de curso" 
                                                    ></v-textarea>
                                                </v-col>
                                                <v-col cols="12" lg="6">
                                                    <v-text-field
                                                        v-model="sbc_search"
                                                        clearable
                                                        dense
                                                        outlined
                                                        hide-details
                                                        label="Buscar"
                                                        append-icon="mdi-magnify"
                                                        color="#818181"
                                                    ></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </template>
                                    <template v-slot:item.user.phone="{ item }">
                                        <v-btn color="success" class="ma-2 white--text" @click="whatsapp(item)">
                                            {{item.user.phone}}
                                            <v-icon right dark>
                                                mdi-whatsapp
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <template v-slot:item.status="{ item }">
                                        <v-chip :color=" item.verified ? 'success' : 'error'">
                                            {{ item.verified ? 'Verificado' : 'Pendiente' }}
                                        </v-chip>
                                    </template>

                                    <template v-slot:item.actions="{ item }">
                                        <v-tooltip right>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon v-bind="attrs" v-on="on">
                                                    <v-icon>mdi-close</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                        <v-card outlined v-else>
                            <v-card-text>
                                <h2 class="text-center" >Sin Alumnos registrados</h2>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props:['dialog','course'],
    data: () => ({
        //data table studentsbycourse,
        whatsapp_message: 'Hola @nombre somos de instituto nuemann vemos que no haz completado tu proceso de inscripcion del curso @curso hay algo en lo que podamos ayudarte?',
        sbc_search:"",
        sbc_loading:false,
        sbc_itemsPerPage:20,
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        sbc_headers:[
            { text:'Nombre', value:"user.fullname"},
            { text:'Correo', value:'user.email' },
            { text:'Teléfono', value:'user.phone'},
            { text:'Fecha', value:'registration_date' },
            { text:'Último pago', value: 'last_payment' },
            { text:'status', value:'status' },
            { text: 'Acciones', value:'actions', sorteable:false},
        ],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo",
            showFirstLastPage:true,
        },
    }),
    methods:{
        whatsapp:function(item)
        {
            var msg = this.whatsapp_message.replace('@nombre', item.user.names).replace('@curso', this.course.name)
            var phone = item.user.phone
            if(phone.startsWith('044'))
                phone=phone.substring(3)
            if(phone.startsWith('+'))
                phone=phone.substring(1)
            else
                phone='52'+phone
            window.open('https://wa.me/'+phone+'?text='+msg)
        }
    },

    computed:{
        total_students_verified:function(){
            let total_students_verified = 0;
            
            if(this.course.students && this.course.students.length > 0){
                for(let student of this.course.students){
                    student.verified ? total_students_verified++ : ''
                }
            }

            return total_students_verified
        }
    }
}
</script>